import React from "react";
import Slider from "react-slick";

class Carousel extends React.Component {

    settings() {
        return {
            dots: this.props.addDots,
            // infinite: false,
            speed: 500,
            slidesToShow: this.props.maxSlides,
            slidesToScroll: 1,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1680,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        initialSlide: 1
                    }
                }
            ]
        }
    }
    render() {
        let slides = this.props.slides.map(slide => {
            return React.createElement(this.props.slideType, {...slide, key: slide.id})
        })

        return (
            <div className="carousel-container">
                <div className="headline">
                    <h2>{this.props.title}</h2>
                </div>
                <Slider {...this.settings()}>
                    {slides}
                </Slider>
            </div>
        );
    }
}

Carousel.defaultProps = {
    maxSlides: 9
}


export default Carousel


// WEBPACK FOOTER //
// components/Carousel.js